import { Goal } from '../../models';

export function validateGoalForm({ metric, unit }: Partial<Goal>): string {
  if (!metric) {
    return 'Debes ingresar una métrica';
  }
  if (!unit) {
    return 'Debes ingresar una unidad';
  }

  return '';
}
